import pdfMake from 'pdfmake/build/pdfmake'

const REMOTE_SOURCE_HAN_FONT = 'https://yunionweb.oss-cn-beijing.aliyuncs.com/fonts/SourceHanSansCN-Normal.ttf'

/** 优先使用 src/assets 下任意层级的 SourceHanSansCN-Normal.ttf（离线部署）；无文件则回退 OSS，不抛错 */
function getSourceHanSansFontUrl () {
  try {
    const ctx = require.context('@/assets', true, /SourceHanSansCN-Normal\.ttf$/)
    const keys = ctx.keys()
    if (!keys.length) return REMOTE_SOURCE_HAN_FONT
    const mod = ctx(keys.sort()[0])
    const url = typeof mod === 'string' ? mod : mod && mod.default
    return url || REMOTE_SOURCE_HAN_FONT
  } catch (e) {
    return REMOTE_SOURCE_HAN_FONT
  }
}

/** pdfmake 仅对 http(s) URL fetch 并写入 vfs；webpack 返回的 /static/... 相对路径不会 fetch，会报 virtual file system 找不到 */
function ensureAbsoluteHttpFontUrl (url) {
  if (!url || typeof url !== 'string') return url
  const t = url.trim()
  if (/^https?:\/\//i.test(t)) return t
  if (typeof window === 'undefined' || !window.location) return t
  try {
    return new URL(t, window.location.href).href
  } catch (e) {
    return t
  }
}

const SOURCE_HAN_FONT_URL = ensureAbsoluteHttpFontUrl(getSourceHanSansFontUrl())

pdfMake.fonts = {
  Roboto: {
    normal: SOURCE_HAN_FONT_URL,
    bold: SOURCE_HAN_FONT_URL,
    italics: SOURCE_HAN_FONT_URL,
    bolditalics: SOURCE_HAN_FONT_URL,
  },
}

export default {
  data () {
    return {
      singleActions: [
        {
          label: this.$t('inspection.operation.view_report'),
          action: (obj) => {
            try {
              const results = JSON.parse(obj.results)
              const docDefinition = this.generateDocDefinition(results, obj)
              pdfMake.createPdf(docDefinition).open()
            } catch (error) {
              this.$message.error(this.$t('inspection.message.view_report_error'))
              throw error
            }
          },
          meta: (obj) => {
            const ret = { validate: true }
            try {
              const results = JSON.parse(obj.results)
              if (Object.keys(results).length === 0) {
                ret.validate = false
              }
              if (obj.status === 'error') {
                ret.validate = false
                ret.tooltip = this.$t('inspection.message.error_can_not_action')
              }
            } catch (error) {
              ret.validate = false
            }
            return ret
          },
        },
        {
          label: this.$t('inspection.operation.download_report'),
          action: (obj) => {
            try {
              const results = JSON.parse(obj.results)
              const docDefinition = this.generateDocDefinition(results, obj)
              const title = `${this.$moment(obj.created_at).format()}-${this.$t('inspection.report')}`
              pdfMake.createPdf(docDefinition).download(title)
            } catch (error) {
              this.$message.error(this.$t('inspection.message.download_report_error'))
              // throw error
            }
          },
          meta: (obj) => {
            const ret = { validate: true }
            try {
              const results = JSON.parse(obj.results)
              if (Object.keys(results).length === 0) {
                ret.validate = false
              }
              if (obj.status === 'error') {
                ret.validate = false
                ret.tooltip = this.$t('inspection.message.error_can_not_action')
              }
            } catch (error) {
              ret.validate = false
            }
            return ret
          },
        },
        {
          label: this.$t('table.action.delete'),
          action: obj => {
            this.createDialog('DeleteResDialog', {
              vm: this,
              data: [obj],
              columns: this.columns,
              title: this.$t('table.action.delete'),
              name: this.$t('inspection.report'),
              onManager: this.onManager,
            })
          },
          meta: obj => this.$getDeleteResult(obj),
          hidden: () => true,
        },
      ],
    }
  },
}
